import axios from "axios";
import { api } from "@/api/apiSlice";
import { backendBase } from "@/api/backendBase";
import type { BackgroundJobScheduleDto } from "@/api/dtos";
import type { BackgroundJobSchedule } from "./_models/BackgroundJobSchedule";
import { toBackgroundJobScheduleFromBackgroundJobScheduleDto } from "./_transformers/toBackgroundJobScheduleFromBackgroundJobScheduleDto";
import { toBackgroundJobFetchError } from "./backgroundJob.utils";
import { BackgroundJobTags } from "./BackgroundJobTags";

/** Every schedule (GET /background-job-schedules), with its next run and latest job. */
export const getBackgroundJobScheduleListApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getBackgroundJobScheduleList: builder.query<BackgroundJobSchedule[], void>({
      queryFn: async () => {
        try {
          const res = await axios.get<BackgroundJobScheduleDto[]>(
            `${backendBase()}/background-job-schedules`,
            { headers: { Accept: "application/json" } },
          );
          const schedules = res.data.map((x) => toBackgroundJobScheduleFromBackgroundJobScheduleDto(x));
          return { data: schedules };
        }
        catch (e) {
          return { error: toBackgroundJobFetchError(e) };
        }
      },
      providesTags: [{ type: BackgroundJobTags.BackgroundJobSchedule, id: "LIST" }],
    }),
  }),
});

export const getBackgroundJobScheduleList = getBackgroundJobScheduleListApi.endpoints.getBackgroundJobScheduleList;
